import { createJsonTheme } from './jsonTheme';
import { markdownTheme } from './markdownTheme';
import type { LanguageMode } from '../types';

export const createThemeForLanguage = (
  readOnly: boolean,
  language: LanguageMode
) => {
  if (language === 'markdown') {
    return markdownTheme;
  }

  return createJsonTheme(readOnly);
};
